import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { templateApi } from '../../services/api';
import { log } from '../../utils/environment';

const CategoryGrid = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const data = await templateApi.getTemplateCategories();
      log.info('Fetched template categories:', data);
      setCategories(data);
    } catch (error) {
      log.error('Error fetching template categories:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const renderIcon = (category) => {
    if (category.icon_type === 'fontawesome') {
      return <i className={category.icon_value} style={{ fontSize: '60px', color: '#87AD9A' }}></i>;
    } else if (category.icon_type === 'svg') {
      return <div dangerouslySetInnerHTML={{ __html: category.icon_value }} />;
    }
    
    return (
      <svg width="85" height="79" viewBox="0 0 85 79" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.9606 2.5V31.2376H2.5V50.7193H31.9606V76.5H53.4613V50.7193H82.5V31.4907L53.4613 31.2376V2.5H31.9606Z" stroke="#87AD9A" strokeWidth="5"/>
      </svg>
    );
  };

  if (loading) {
    return (
      <section className="categories">
        <div className="container">
          <h2>Build Resumes for Every Category</h2>
          <p>Loading categories...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="categories">
      <div className="container">
        <h2>Build Resumes for Every Category</h2>
        <p>Choose your profession and create a job-ready resume or professional slip in minutes — no design skills required.</p>

        <div className="category-list">
          {categories.map((category) => (
            <Link 
              to={`/templates?category=${category.slug}`}
              className="category-item" 
              key={category.id}
              title={`View ${category.name} templates`}
            >
              <div className="category-icon">
                {renderIcon(category)}
              </div>
              <h4>
                {category.name.split(" & ").map((part, i) => (
                  <React.Fragment key={i}>
                    {part}
                    {i < category.name.split(" & ").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h4>
              {category.template_count > 0 && (
                <span className="template-count">
                  {category.template_count} {category.template_count === 1 ? 'template' : 'templates'}
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;